import React from "react"
import { FormZone } from "../../ts/interfaces"
import PaddedContainer from "../ui/PaddedContainer"
import { SectionTitle } from "../ui/Title"

import { Box } from "@mui/system"

const Form = (section: FormZone) => {
  const { formId, formTitle, formSubTitle } = section

  return (
    <PaddedContainer>
      <SectionTitle title={formTitle} subtitle={formSubTitle} />
      <Box className="typeform-embed" data-tf-live={formId}></Box>
      <script src="https://embed.typeform.com/next/embed.js" />
    </PaddedContainer>
  )
}

export default Form
